module.exports = __webpack_public_path__ + "media/images/ir/profile/photo_nakamura-95680faa4c4ee0254b77a23ebae6354c.jpg";